import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MomentsRunService } from './run/moments-run.service';


export function initializeMomentsRunService (momentsRunService: MomentsRunService): () => void {
    return () => momentsRunService.initializeApp();
}

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeMomentsRunService,
            deps: [MomentsRunService],
            multi: true,
        },
    ],
})
export class MomentsModule {}
